import Feed from 'semantic-ui-react/dist/commonjs/views/Feed';
import '@purple/semantic-ui-purple-theme/components/feed.css';

export default Feed;
